
import { StdResponse, request } from "@/global/config/request";
import { EavesBoard } from "@/global/interface/archi/eaves-board";
import { Station, StationItem } from "@/global/interface/archi/station";
import localStore from "@/global/store/local-store";
import qs from "qs";

export function addEavesBoard(projectId: number, data: EavesBoard, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/eaves-boards`, data, {
        params: {
            ...params,
        }
    })
}

export function findEavesBoardsByProjectId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/eaves-boards`, {
        params: {
            ...params,
        }
    })
}

export function updateEavesById(id: number, data: EavesBoard, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/eaves-boards/${id}`, data, {
        params: {
            ...params,
            projectId: localStore.projectId,
        },

    })
}

export function deleteEavesBoardByIdList(ids: number[], params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/eaves-boards`, {
        params: {
            ids: ids,
            ...params,
            projectId: localStore.projectId,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}